import React, { Component } from 'react'

export default class Maintainance extends Component {
    render() {
        return (
            <div>
                
            </div>
        )
    }
}
